import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import AppLayout from "../components/Layout";

import { SignIn, SignUp } from "../pages/Authentication";
import Contact from "../pages/Contact";
import Privacy from "../pages/Privacy";
import Terms from "../pages/Termsofuse";

import { ROUTES } from "./constant";

import PrivateRoute from "./Private.route";
import PublicRoute from "./Public.route";

const Routes = () => {
  return (
    <BrowserRouter>
      <AppLayout>
        <Switch>
        
        
          <PublicRoute
            restricted={true}
            component={SignIn}
            path={ROUTES.SIGNIN}
            exact
          />
          <PublicRoute
            restricted={true}
            component={SignUp}
            path={ROUTES.SIGNUP}
            exact
          />
          <PublicRoute
            restricted={true}
            component={Contact}
            path={ROUTES.CONTACT}
            exact
          />
             <PublicRoute
            restricted={true}
            component={Privacy}
            path={ROUTES.PRIVACY}
            exact
          />
            <PublicRoute
            restricted={true}
            component={Terms}
            path={ROUTES.TNC}
            exact
          />
        
        </Switch>
      </AppLayout>
    </BrowserRouter>
  );
};

export default Routes;
